import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { di } from 'react-magnetic-di';
import { useAISummary } from '../../../../../state/hooks/use-ai-summary';
import { CopySummaryAction } from './copy-summary-action';
import { AISummariseAction } from './ai-summarise-action';
export const AISummaryActionComponent = props => {
  const {
    url,
    ari,
    product,
    onLoadingChange,
    testId = 'smart-action-ai-summary-action'
  } = props;
  const {
    state: {
      status,
      content
    },
    summariseUrl
  } = useAISummary({
    url,
    ari,
    product
  });
  useEffect(() => {
    onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(status === 'loading');
  }, [onLoadingChange, status]);
  return status === 'done' ? /*#__PURE__*/React.createElement(CopySummaryAction, _extends({}, props, {
    testId: testId,
    content: content
  })) : /*#__PURE__*/React.createElement(AISummariseAction, _extends({}, props, {
    testId: testId,
    summariseUrl: summariseUrl,
    status: status
  }));
};